export function getCoupleDisplayFullName(couple) {
  if (!couple) return "";

  return `${couple[0].first_name || ""} ${couple[0].last_name || ""} & ${
    couple[1].first_name || ""
  } ${couple[1].last_name || ""}`;
}

export function getCoupleDisplayShortName(couple) {
  if (couple[0].last_name && couple[1].last_name) {
    return `${
      couple[0].first_name
    } ${couple[0].last_name[0].toUpperCase()}. & ${
      couple[1].first_name
    } ${couple[1].last_name[0].toUpperCase()}.`;
  } else {
    return null;
  }
}
